import { Button, Typography } from '@mui/material';
import Box from '@mui/material/Box/Box';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { LogoQuestionMark } from '../../components/LogoQuestionMark';

interface ErrorPageProps {
  errorMessage: string;
}

const ErrorPage = (props: ErrorPageProps): JSX.Element => {
  const { errorMessage } = props;

  let message = '';
  switch (errorMessage.toLowerCase()) {
    case 'gone':
      message = 'The resource has been deleted.';
      break;
    case 'invalid state':
      message = 'The resource is in an invalid state. Please reload the page or fix the resource.';
      break;
    case 'networkerror when attempting to fetch resource.':
      message = 'An error occurred while fetching the resource. Please try again later.';
      break;
    default:
      message = errorMessage;
      break;
  }

  return (
    <Box style={{ textAlign: 'center' }}>
      <Box sx={{ width: '100%' }}>
        <LogoQuestionMark width="100%" />
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
        Whoops there was an error: {message}
      </Typography>
      <Typography variant="h5" mt={1}>
        Sorry about that, but here is the way out...
      </Typography>
      <Button component={Link} to="/" aria-label="return to console" variant="contained" sx={{ mt: 4 }}>
        console landing page
      </Button>
    </Box>
  );
};

export default ErrorPage;
